/** @format */

import template from './gb-custom-css-panel.html';
import './gb-custom-css-panel.scss';

export const GbCustomCssPanelComponent = {
    template,
    require: {
        gbEditTools: '^^',
        gbApp: '^^',
    },
    controller: class GbCustomCssPanelComponent {
        constructor($gbProjector, $ccToast, $translate) {
            'ngInject';
            this.$gbProjector = $gbProjector;
            this.$ccToast = $ccToast;
            this.$translate = $translate;
        }

        $onInit() {
            this.originalCss = angular.copy(this.getCustomCss().custom_css);
        }

        getCustomCss() {
            return this.gbApp.getProjector();
        }

        revert() {
            return (this.gbApp.getProjector().custom_css = this.originalCss);
        }

        checkDisabled() {
            return this.originalCss === this.getCustomCss().custom_css;
        }

        save() {
            this.customCss = this.getCustomCss();

            return this.$gbProjector.cache
                .fromPromise(this.customCss.$save())
                .then(() => this.$ccToast.success(this.$translate.instant('EDIT_TOOLS_CUSOM_CSS_SAVE_TOAST')))
                .catch((err) => this.$ccToast.error(err));
        }

        close() {
            this.gbEditTools.closeCustomCssPanel();
        }
    },
};
